// extracted by mini-css-extract-plugin
export default {"wrapper":"ProjectTitle_wrapper__0YqCF","save":"ProjectTitle_save__5xzrk"};